import React from "react";
import { Container, Text } from "@mantine/core";

const Clients: React.FC = () => {
  return (
    <Container py="xl">
      <Text size="xl">Klienci</Text>
    </Container>
  );
};

export default Clients;
